import { render, staticRenderFns } from "./scene10.vue?vue&type=template&id=dac5a0fe&scoped=true&"
import script from "./scene10.vue?vue&type=script&lang=ts&"
export * from "./scene10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5a0fe",
  null
  
)

export default component.exports